export const receivedInvoice = 'RECEIVED_INVOICE';
export const cancelledInvoice = 'CANCELLED_INVOICE';
export const filedInvoice = 'FILED_INVOICE';
export const conciliatedInvoice = 'CONCILIATED_INVOICE';
export const authInvoice = 'ON_PAYMENT_AUTH_INVOICE';
export const paidInvoice = 'PAID_INVOICE';

export const stateTypes = [authInvoice, conciliatedInvoice, paidInvoice];